import { render, staticRenderFns } from "./VisitQuickInfo.vue?vue&type=template&id=3bc2d748&scoped=true&"
import script from "./VisitQuickInfo.vue?vue&type=script&lang=js&"
export * from "./VisitQuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./VisitQuickInfo.vue?vue&type=style&index=0&id=3bc2d748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc2d748",
  null
  
)

export default component.exports